import React from 'react';
import { SearchIcon, XIcon } from 'lucide-react';

export function SearchField({ value, onChange, placeholder, label, autoFocus, onKeyDown, className = '', inputRef, shortcutHint }) {
  return (
    <div className={`tw-relative ${className}`}>
      <SearchIcon className="tw-pointer-events-none tw-absolute tw-left-3 tw-top-1/2 tw-h-4 tw-w-4 -tw-translate-y-1/2 tw-text-neutral-400" aria-hidden />
      <input
        ref={inputRef}
        type="search"
        value={value}
        onChange={e => onChange(e.target.value)}
        onKeyDown={e => {
          if (e.key === 'Escape' && value) {
            e.stopPropagation();
            onChange('');
          }
          onKeyDown?.(e);
        }}
        placeholder={placeholder}
        aria-label={label}
        aria-keyshortcuts={shortcutHint}
        autoFocus={autoFocus}
        className="tw-peer tw-h-9 tw-w-full tw-rounded-lg tw-border tw-border-neutral-200 tw-bg-white tw-pl-9 tw-pr-9 tw-text-sm tw-text-neutral-900 tw-outline-none tw-transition-[border-color,box-shadow] tw-duration-150 placeholder:tw-text-neutral-400 focus:tw-border-brand-500 focus:tw-ring-2 focus:tw-ring-brand-500/20 [&::-webkit-search-cancel-button]:tw-hidden"
      />
      {value ? (
        <button
          type="button"
          onClick={() => onChange('')}
          aria-label="Clear search"
          className="tw-absolute tw-right-2 tw-top-1/2 -tw-translate-y-1/2 tw-rounded tw-p-0.5 tw-text-neutral-400 tw-transition-colors hover:tw-text-neutral-900">
          <XIcon className="tw-h-3.5 tw-w-3.5" />
        </button>
      ) : (
        shortcutHint && (
          <kbd className="tw-pointer-events-none tw-absolute tw-right-2 tw-top-1/2 -tw-translate-y-1/2 tw-rounded tw-border tw-border-neutral-200 tw-bg-sand-50 tw-px-1.5 tw-font-sans tw-text-[11px] tw-text-neutral-400 peer-focus:tw-hidden">
            {shortcutHint}
          </kbd>
        )
      )}
    </div>
  );
}
